import React from "react";
import { useTranslation } from "react-i18next";

import "./Steps.css";

interface RfrMultipleCheckboxesProps {
    name: string,
    className?: string,
    options: Array<string>,
    data: Array<string>,
    setData: (name: string, value: Array<string>) => void
}

export default function RfrMultipleCheckboxes(props: RfrMultipleCheckboxesProps) {
    const { t } = useTranslation("rfr");
    const choosen = props.data[props.name];

    const handleChangeOption = (e) => {
        const { name, value, checked } = e.target;
        if (checked && !choosen.includes(value)) {
            props.setData(name, [...choosen, value]);
        }
        if (!checked && choosen.includes(value)) {
            const array = [...choosen]; // make a separate copy of the array
            const index = array.indexOf(value)
            if (index !== -1) {
                array.splice(index, 1);
                props.setData(name, array);
            }
        }
    }

    return (
        <>
            {
                props.options.map((option, index) => {
                    return (
                        <div className="rfr-form-row-checkbox" key={props.name + "_" + index}>
                            <div className="rfr-input-checkbox-block">
                                <input onChange={(e) => handleChangeOption(e)} type="checkbox" name={props.name} id={props.name + "_" + index} value={option.labelkey} checked={choosen.includes(option.labelkey)} />
                            </div>
                            <div className="rfr-form-row-options">
                                <label htmlFor={props.name + "_" + index} className="font-blue">{t(option.labelkey)}</label>
                            </div>
                        </div>
                    )
                })
            }
        </>
    )
}
